// extracted by mini-css-extract-plugin
export var assigneeBadge = "_oa-0";
export var assigneeDetails = "_oa-1";
export var assigneeInfo = "_oa-2";
export var dropdownContainer = "_oa-4";
export var dropdownImage = "_oa-5";
export var editAssigneeInfo = "_oa-3";
export var editAssigneeModalContainer = "_oa-6";
export var hidden = "_oa-8";
export var input = "_oa-7";